import axios from "axios";
import {objToFormData} from "../helpers";

export default class {
    static get uri() {
        return 'profile';
    }

    static update(params) {
        return axios.put(`${this.uri}`, params);
    }

    static setViberToken(token) {
        return axios.post('/viber/token', objToFormData({
            'token': token,
        }))
    }

    static setTelegramToken(token) {
        return axios.post('/telegram/token', objToFormData({
            'token': token,
        }))
    }
}
